// eslint-disable-next-line import/prefer-default-export
export const linkImage = `${process.env.PUBLIC_URL}/img/link.svg`;
